import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.search";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import tempTable from "@/components/rw/tempTable/index";
import tempSearch from "@/components/rw/tempSearch/index";
import tempForm from "@/components/rw/tempForm/index";
import tempChart from "@/components/rw/tempChart/index";
import { tonglianPaymentList } from '@/api/apis';
export default {
  components: {
    tempTable: tempTable,
    tempSearch: tempSearch,
    tempForm: tempForm,
    tempChart: tempChart
  },
  data: function data() {
    var _this = this;

    return {
      name: 'payLog',
      searchModel_1000: {
        "del": false,
        "id": "id_1000",
        "isCollapse": false,
        "operateData": [{
          "icon": "el-icon-search",
          "tag": "search",
          "title": "搜索",
          "type": "primary"
        }, {
          "icon": "el-icon-position",
          "tag": "export",
          "title": "导出",
          "type": "primary"
        }],
        "searchData": [{
          "children": [{
            "field": [],
            "title": "全部",
            "type": "button"
          }, {
            "field": [{
              "key": "order_status",
              "value": "0"
            }],
            "title": "预生成",
            "total": 0,
            "type": "button"
          }, {
            "field": [{
              "key": "order_status",
              "value": "1"
            }],
            "title": "未支付",
            "type": "button"
          }, {
            "field": [{
              "key": "order_status",
              "value": "3"
            }],
            "title": "交易失败",
            "type": "button"
          }, {
            "field": [{
              "key": "order_status",
              "value": "4"
            }],
            "title": "交易成功",
            "total": 0,
            "type": "button"
          }, {
            "field": [{
              "key": "order_status",
              "value": "6"
            }],
            "title": "关闭",
            "total": 0,
            "type": "button"
          }, {
            "field": [{
              "key": "order_status",
              "value": "99"
            }],
            "title": "进行中",
            "total": 0,
            "type": "button"
          }],
          "id": 0,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "select": 0,
          "title": "支付状态",
          "type": 0,
          "remoteFunc": []
        }, {
          "children": [{
            "field": [],
            "title": "全部",
            "type": "button"
          }, {
            "field": [],
            "title": "今天",
            "type": "button"
          }, {
            "field": [],
            "title": "昨天",
            "type": "button"
          }, {
            "field": [],
            "title": "最近7天",
            "type": "button"
          }, {
            "field": [],
            "title": "本月",
            "type": "button"
          }, {
            "field": [],
            "title": "本年",
            "type": "button"
          }, {
            "field": [],
            "title": "自定义",
            "type": "custom-datetime-range"
          }],
          "id": 1,
          "relation": false,
          "relationId": "",
          "remote": true,
          "remoteType": 1,
          "select": 0,
          "title": "支付日期",
          "type": 1,
          "remoteFunc": ["modelConditionFunc_1"]
        }, {
          "children": [{
            "field": [{
              "desc": "店铺账号",
              "key": "user_number",
              "value": ""
            }],
            "operator": ["gte", "lte", "gt", "lt", "eq", "ne", "like", "notLike", "in", "between"],
            "placeholder": "请输入",
            "type": "input-complex"
          }, {
            "field": [{
              "desc": "通联账户",
              "key": "biz_user_id"
            }],
            "operator": [],
            "placeholder": "请输入",
            "type": "input-complex"
          }, {
            "type": "input-complex",
            "placeholder": "请输入",
            "field": [{
              "key": "biz_order_no",
              "desc": "通联订单号"
            }],
            "operator": []
          }, {
            "type": "input-complex",
            "placeholder": "请输入",
            "field": [{
              "key": "order_no",
              "desc": "订单号"
            }],
            "operator": []
          }],
          "id": 2,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "select": 0,
          "title": "按条件",
          "type": 2,
          "remoteFunc": []
        }],
        "type": "searchTemplate"
      },
      tableModel_1001: {
        "border": true,
        "del": false,
        "headerButton": [],
        "id": "id_1001",
        "isGroup": false,
        "isTree": false,
        "rowButton": [],
        "showPagination": true,
        "showSelection": false,
        "showSummary": false,
        "stripe": true,
        "tableAutocompleteProps": {},
        "tableCascaderProps": {},
        "tableFileProps": {},
        "tableModel": [{
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "ID",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "60",
          "prop": "id"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "店铺账号",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "80",
          "prop": "user_number"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "通联订单号",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "biz_order_no"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "通联账户",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "biz_user_id"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "公司名称",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "t_balance_company.company_name"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "订单号",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "order_no"
        }, {
          "add": 0,
          "desc": "",
          "detail": 0,
          "excel": 0,
          "groupId": "",
          "label": "分账",
          "rules": [],
          "show": 0,
          "type": "custom",
          "width": "250",
          "prop": "split_rule"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "金额",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "80",
          "prop": "amount"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "手续费",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "80",
          "prop": "fee"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "支付状态",
          "rules": [],
          "show": 1,
          "type": "select",
          "width": "80",
          "prop": "order_status"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "是否记账",
          "rules": [],
          "show": 1,
          "type": "select",
          "width": "80",
          "prop": "is_account_success"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "支付日期",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "pay_datetime"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "创建日期",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "created_at"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "",
          "label": "更新日期",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "updated_at"
        }],
        "tableName": "",
        "tableRadioProps": {},
        "tableSelectProps": {
          "order_status": {
            "data": [{
              "key": 1,
              "value": "未支付"
            }, {
              "key": 3,
              "value": "交易失败"
            }, {
              "key": 4,
              "value": "交易成功"
            }, {
              "key": 5,
              "value": "退款"
            }, {
              "key": 6,
              "value": "关闭"
            }, {
              "key": 99,
              "value": "进行中"
            }, {
              "key": 8,
              "value": "退票"
            }, {
              "key": 0,
              "value": "预生成"
            }],
            "id": 0,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": false
          },
          "is_account_success": {
            "data": [{
              "key": 0,
              "value": "否"
            }, {
              "key": 1,
              "value": "是"
            }],
            "id": 1,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": false
          }
        },
        "tableSwitchProps": {},
        "title": "支付日志",
        "type": "tableTemplate"
      },
      remoteFunc: {
        modelConditionFunc_1: function modelConditionFunc_1(tag, relationData, resolve) {
          //筛选条件数据
          //[[{key:"type",value:"1"}]]
          var data = [];
          data = [[{
            key: "pay_datetime",
            value: []
          }], [{
            key: "pay_datetime",
            value: _this.$g.fun.getDateRange(new Date(), 0, true)
          }], [{
            key: "pay_datetime",
            value: _this.$g.fun.getDateRange(new Date(), 1, true)
          }], [{
            key: "pay_datetime",
            value: _this.$g.fun.getDateRange(new Date(), 7, true)
          }], [{
            key: "pay_datetime",
            value: _this.$g.fun.getDateRange(new Date(), 30, true)
          }], [{
            key: "pay_datetime",
            value: _this.$g.fun.getDateRange(new Date(), 365, true)
          }], [{
            key: "pay_datetime",
            value: []
          }]];
          resolve(tag, data);
        }
      }
    };
  },
  mounted: function mounted() {
    this.table = this.$refs.ref_1001;
    this.search = this.$refs.ref_1000;
  },
  methods: {
    reqTableData: function reqTableData(params, resolve) {
      var where = {};

      if (this.search) {
        where = this.search.parseWhere();
        params.where = where;
      }

      tonglianPaymentList(params).then(function _callee(res) {
        var i, item, info, j, rule;
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                for (i in res.rows) {
                  item = res.rows[i];
                  info = '';

                  for (j in item.split_rule) {
                    rule = item.split_rule[j];
                    info += '[' + rule.bizUserId + ']' + rule.remark + " 金额：" + rule.amount + " 手续费：" + rule.fee + "\n";
                  }

                  item.split_rule = info;
                }

                resolve({
                  total: res.count,
                  data: res.rows
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        });
      });
    },
    reqAdd: function reqAdd(isEdit, params, row, resolve) {//if (isEdit){
      //  params.id = row.id
      //}
      //xxxAdd(params).then(async res=>{
      //  resolve()
      //})
    },
    reqDel: function reqDel(params, resolve) {
      var ids = params.map(function (item) {
        return item.id;
      }); //xxxDel({id:ids}).then(async res=>{
      //  resolve()
      //})
    },
    onClickLink: function onClickLink(prop, row) {//点击列表link类型回调
    },
    onClickRowButton: function onClickRowButton(btnIndex, row) {//点击列表按钮回调
    },
    onClickHeaderButton: function onClickHeaderButton(btnIndex, row) {//点击列表头部按钮回调
    },
    onSummary: function onSummary(param) {//列表尾部合计回调
    },
    onSwitchChange: function onSwitchChange(val, prop, row) {//列表中switch变化事件
    },
    onClickSearchOperate: function onClickSearchOperate(btnIndex, btnData) {
      //条件菜单按钮点击事件
      if (btnData.tag === this.$tempModel.buttonTag.search) {
        this.table.reloadData();
      } else if (btnData.tag === this.$tempModel.buttonTag.export) {
        this.table.exportExcel();
      } else if (btnData.tag === this.$tempModel.buttonTag.import) {
        var header = btnData.header;
        var results = btnData.results;
      }
    },
    onConditionChange: function onConditionChange(tag, index) {
      this.table.reloadData();
    },
    onRowButtonShow: function onRowButtonShow(btnIndex, row) {
      return true;
    }
  }
};